import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/auth/redefinir-senha")({
	// biome-ignore lint/suspicious/noExplicitAny: TODO
	validateSearch: (search: Record<string, any>): { encode?: string } => ({
		encode: search?.encode,
	}),
});
